import React from 'react';
import { UserRankingItemTop1 } from './UserRankingItemTop1';

interface UserRankingItemProps {
  position: number;
  userName: string;
  deliveredCount: number;
  maxCount: number;
}

export const UserRankingItem: React.FC<UserRankingItemProps> = (props) => {
  
  const { position, userName, deliveredCount, maxCount } = props;

  if (position === 1) {
    return <UserRankingItemTop1 {...props} />;
  }

  return (
    <div className="flex items-center gap-3 p-3 rounded-xl border transition-all duration-300 bg-slate-50/80 border-slate-100 group hover:bg-slate-100/80">
      <div className="flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-sm font-black tabular-nums bg-slate-200 text-slate-600 group-hover:bg-slate-300">
        {position}
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold truncate text-slate-700">
          {userName}
        </p>
        <div className="h-2 mt-1.5 bg-slate-200 rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500 bg-slate-400"
            style={{
              width: `${maxCount > 0 ? (deliveredCount / maxCount) * 100 : 0}%`,
            }}
          />
        </div>
      </div>
      <span className="flex-shrink-0 text-sm font-black tabular-nums px-2.5 py-1 rounded-lg bg-slate-100 text-slate-700">
        {deliveredCount}
      </span>
    </div>
  );
};
